import { IconButton } from '@material-ui/core'
import React from 'react'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const PortionSelector = ({ portions, setPortions }) => {

    const addPortion = () => {
        setPortions(portions+1);
      }

      const decreasePortion = () => {
        setPortions(portions-1);
      }


    return (
            <div className="shrink">
                    <label>Portions</label>                
                    <IconButton onClick = {decreasePortion}>
                        <RemoveCircleOutlineIcon></RemoveCircleOutlineIcon>
                    </IconButton>
                    <input key="portionsForQuantity" type="number" min="1" max="20" value={portions} onChange={(e) => setPortions(e.target.value)}></input>
                    <IconButton onClick = {addPortion}>
                        <AddCircleOutlineIcon></AddCircleOutlineIcon>
                    </IconButton>
                
            </div>
    )
}

export default PortionSelector
